/**
 * Centralized API Configuration
 * This file contains all API-related configuration settings
 * to avoid duplication across multiple API files.
 */

export const API_URL ="https://i8qp3i3gk3.execute-api.ap-south-1.amazonaws.com/LiveMode";
// export const API_URL ="http://127.0.0.1:3000";

export const MARKETING_API_URL ="https://abjrfh64q6.execute-api.ap-south-1.amazonaws.com/LiveMode";
export const PEOPLE_API_URL = "https://ocoruysjl5.execute-api.ap-south-1.amazonaws.com/LiveMode"

// Alternative API URLs (if you have different endpoints)
export const COUNTRY_API_URL =
  "https://abjrfh64q6.execute-api.ap-south-1.amazonaws.com/LiveMode/account-settings/loadCountry/All";

  // export const COUNTRY_API_URL =
  // "http://127.0.0.1:3000/account-settings/loadCountry/All";  

export const CRM_API_URL = "https://97ny4m4be2.execute-api.ap-south-1.amazonaws.com/LiveMode";

// export const AI_CHAT_API_URL = "https://uy9nfxntoh.execute-api.us-west-2.amazonaws.com/PilotMode";

// export const S3_UPLOAD_BASE_URL =
//   "https://9x8u208ej1.execute-api.ap-south-1.amazonaws.com/FlightMode";


  // All Demo Link - Need to updated later
//   export const SOCIAL_MEDIA_LINKS = {
//   facebook: "https://www.facebook.com/profile.php?id=61584405770747",
//   instagram: "https://www.instagram.com/oruclicks/",
//   linkedin: "https://www.linkedin.com/company/oruclicks/",
//   whatsapp: null, // Coming soon
//   youtube: "https://www.youtube.com/@OruClicks", // Coming soon
// };

export const COMPANY_INFO = {
  name: "OruClick",
  description:
    "The ultimate AI-powered social media automation platform. Streamline your content, amplify your reach, and grow your brand with cutting-edge technology.",
  email: "contact@oruclicks.com",
  founded: new Date().getFullYear(),
};

export const FOOTER_LINKS = {
  product: [
    { label: "Features", url: "/" },
    { label: "Pricing", url: "/pricing" },
    { label: "Integrations", url: "/" },
    { label: "Updates", url: "/" },
  ],
  company: [
    { label: "About Us", url: "/" },
    { label: "Careers", url: "https://www.career.oruclicks.com", target: "_blank" },
    { label: "Blog", url: "/" },
    { label: "Press Kit", url: "/" },
    { label: "Contact", url: "/contact" },
  ],
  resources: [
    { label: "Help Center", url: "/" },
    { label: "Community", url: "/" },
    { label: "Tutorials", url: "/" },
    { label: "Webinars", url: "/" },
    { label: "Status", url: "/" },
  ],
  legal: [
    { label: "Privacy Policy", url: "https://www.oruclicks.com/privacy-policy" },
    { label: "Terms of Service", url: "https://www.oruclicks.com/termsandconditions" },
    { label: "Cookie Policy", url: "/" },
    { label: "GDPR", url: "/" },
  ],
};

// TODO: switch to "https://www.app.oruclick.com/login" once that app is live
export const LOGIN_URL = "https://www.oruclicks.com/login";

export const APP_CONFIG = {
  // Product Information
  PRODUCT_NAME: "OruClick",
  PRODUCT_VERSION: "1.0.0",
  
  // API Configuration
  DEFAULT_CLIENT_ID: "Oruclicks",
  
  // Social Media Limits
  MAX_IMAGE_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_VIDEO_SIZE: 50 * 1024 * 1024, // 50MB
  MAX_IMAGES: 10,
  MAX_VIDEOS: 5,
  
  // Date/Time Formats
  DATE_FORMAT: "YYYY-MM-DD",
  TIME_FORMAT: "HH:mm:ss",
  DATETIME_FORMAT: "YYYY-MM-DDTHH:mm:ss",
  
  // UI Configuration
  SNACKBAR_DURATION: 4000,
  
  // Storage Keys
  STORAGE_KEYS: {
    CLIENT_ID: "clientId",
    USER_TOKEN: "userToken",
    USER_DATA: "userData",
  },
};

// Export individual values for convenience
export const {
  PRODUCT_NAME,
  PRODUCT_VERSION,
  DEFAULT_CLIENT_ID,
  MAX_IMAGE_SIZE,
  MAX_VIDEO_SIZE,
  MAX_IMAGES,
  MAX_VIDEOS,
  STORAGE_KEYS,
} = APP_CONFIG;

export default APP_CONFIG;